namespace TabAurous.Inventory {
    export interface MeltingReturnItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.LookupEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        Weight: WeightEditor;
        Line_No: Serenity.StringEditor;
        NetWeight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        CalcOnId: Serenity.LookupEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
    }

    export class MeltingReturnItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MeltingReturnItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MeltingReturnItemsForm.init)  {
                MeltingReturnItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = WeightEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.DateEditor;

                Q.initFormType(MeltingReturnItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'BagNo', w0,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w2,
                    'AttributeId', w0,
                    'ProductTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'Weight', w5,
                    'Line_No', w0,
                    'NetWeight', w5,
                    'Purity', w6,
                    'PureWeight', w5,
                    'CalcOnId', w2,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w7,
                    'CompanyId', w1,
                    'BagStatus', w0
                ]);
            }
        }
    }
}
